var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlobIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blobIcon_svg__clip0_1461_9287)",
    stroke: "#001529",
    strokeOpacity: 0.64,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.667A6.667 6.667 0 108 1.334a6.667 6.667 0 000 13.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.333 6.4c0-.373 0-.56.073-.703a.667.667 0 01.291-.29c.143-.074.33-.074.703-.074h3.2c.373 0 .56 0 .703.073a.667.667 0 01.29.292c.074.142.074.329.074.702v3.2c0 .374 0 .56-.073.703a.666.666 0 01-.291.291c-.143.073-.33.073-.703.073H6.4c-.373 0-.56 0-.703-.073a.666.666 0 01-.291-.291c-.073-.143-.073-.33-.073-.703V6.4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blobIcon_svg__clip0_1461_9287"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgBlobIcon;